import React from 'react';
import FieldRow from 'components/FormElements/FieldRow';
import CompanyCard from './CompanyCard';
import RecordView from 'components/RecordView';
import { styled } from '@mui/material/styles';
import { sanitiseHtml } from 'further-ui/utils';

type Props = any; //TODO: define props

const StyledAttachedFileLink = styled('a')(({ theme }) => ({
  fontSize: theme.fontSizes?.sm,
  color: theme.palette.text.primary,

  '&:hover': {
    color: theme.palette.text.rootColor,
  },
}));

const StyledAttachmentItem = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '8px',
}));

const Summary: React.FC<Props> = ({ data, company }) => {
  return (
    <RecordView>
      <FieldRow title={'Subject line'} centerTitle>
        {data?.subject || '-'}
      </FieldRow>
      <FieldRow title="Email title text" centerTitle>
        {data?.title}
      </FieldRow>
      <FieldRow title="Email top paragraph" centerTitle>
        <div
          className="text-editor"
          dangerouslySetInnerHTML={{
            __html: sanitiseHtml(data?.emailTopParagraph) ?? '',
          }}
        />
      </FieldRow>
      <CompanyCard company={company} />
      <FieldRow title="Email bottom paragraph" centerTitle>
        <div
          className="text-editor"
          dangerouslySetInnerHTML={{
            __html: sanitiseHtml(data?.emailBottomParagraph) ?? '',
          }}
        />
      </FieldRow>
      {data?.fileAttachments && data.fileAttachments.length > 0 && (
        <FieldRow title="Email attachment(s)" centerTitle>
          {data?.fileAttachments && data.fileAttachments.length > 0 && (
            <div>
              {data.fileAttachments.map((attachment, index) => (
                <StyledAttachmentItem key={index}>
                  <StyledAttachedFileLink
                    href={attachment.preview || attachment.path}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {attachment.name}
                  </StyledAttachedFileLink>
                </StyledAttachmentItem>
              ))}
            </div>
          )}
        </FieldRow>
      )}
    </RecordView>
  );
};

export default Summary;
